import { render } from "./mappedFieldsComponent.vue?vue&type=template&id=fe1f964e&scoped=true"
import script from "./mappedFieldsComponent.vue?vue&type=script&lang=js"
export * from "./mappedFieldsComponent.vue?vue&type=script&lang=js"

import "./mappedFieldsComponent.vue?vue&type=style&index=0&id=fe1f964e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe1f964e"]])

export default __exports__